import React from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router'
import {
  Divider,
  Grid,
  Step,
  StepLabel,
  Stepper,
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import { DescricoesVestigiosExame } from 'components/DescricoesVestigiosExame'
import { AnaliseConstatacao } from '../ExameConstatacao/AnaliseConstatacao'
import { useExameQuimico } from './useExameQuimico'
import { useStyles } from './ExameQuimico.styles'

export const ExameQuimico = (props) => {
  const { route } = props
  const params = useParams()
  const classes = useStyles()

  const {
    exameRealizado,
    activeStep,
    processandoAlteracaoRespostas,
    handleEtapaAnterior,
    handleProximaEtapa,
    handleVoltar,
  } = useExameQuimico(params.idExameRealizado)

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={`Exame ${exameRealizado?.numeroExame || ''}`} overline={route.secao} />

      <Stepper alternativeLabel activeStep={activeStep} className={classes.stepper}>
        <Step key="Descrições técnicas dos vestígios">
          <StepLabel className={classes.stepLabel}>
            Descrições técnicas dos vestígios
          </StepLabel>
        </Step>
        <Step key="Análises dos vestígios">
          <StepLabel className={classes.stepLabel}>
            Análises dos vestígios
          </StepLabel>
        </Step>
      </Stepper>

      <Grid container>
        {activeStep === 0 && (
          <Grid item xs={12}>
            <SecaoGenerica titulo="DESCRIÇÕES TÉCNICAS DOS VESTÍGIOS" spacing={2}>
              <DescricoesVestigiosExame
                idExameSolicitado={params.idExameSolicitado}
                idExameRealizado={params.idExameRealizado}
              />
            </SecaoGenerica>
          </Grid>
        )}

        {activeStep === 1 && (
          <Grid item xs={12}>
            <SecaoGenerica titulo="ANÁLISES DOS VESTÍGIOS" spacing={2}>
              <AnaliseConstatacao
                idExameSolicitado={params.idExameSolicitado}
                idExameRealizado={params.idExameRealizado}
                definitivo={true}
              />
            </SecaoGenerica>
          </Grid>
        )}
      </Grid>



      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
        <Grid item>
          {activeStep === 0 ? (
            <CustomButton
              variant="outlined"
              onClick={handleVoltar}
              disabled={processandoAlteracaoRespostas}
              startIcon={<ArrowBackIcon />}
            >
              Voltar
            </CustomButton>
          ) : (
            <CustomButton
              variant="outlined"
              colorType="primary"
              onClick={handleEtapaAnterior}
              disabled={processandoAlteracaoRespostas}
              startIcon={<NavigateBeforeIcon />}
            >
              Etapa anterior
            </CustomButton>
          )}
        </Grid>
        <Grid item>
          <CustomButton
            variant="contained"
            colorType={activeStep === 1 ? 'success' : 'primary'}
            onClick={handleProximaEtapa}
            isLoading={processandoAlteracaoRespostas}
            startIcon={activeStep === 1 ? <SaveIcon /> : <NavigateNextIcon />}
          >
            {activeStep === 1 ? 'Finalizar' : 'Próxima Etapa'}
          </CustomButton>
        </Grid>
      </Grid>
    </Page>
  )
}

ExameQuimico.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
  }).isRequired,
}
